// Shared by Calendar.jsx and AdminEventForm.jsx so both legends stay in
// sync from one source instead of two copies that could quietly drift
// apart. DAY_THEMES is the flyer's permanent per-weekday branding — not
// the same thing as the DB's tasks.daily_theme cycle-tracking field
// (that's a project-management concept on internal tasks, unrelated).
//
// color: distinct accent per day/phase for the legend UI, not part of
// the flyer's original design — added purely to make the two lists
// visually scannable at a glance.

export const DAY_THEMES = [
  { label: 'Sunday', theme: 'COMMUNITY', color: '#D16A4B' },
  { label: 'Monday', theme: 'HEALING', color: '#2A8F85' },
  { label: 'Tuesday', theme: 'MEDITATION', color: '#8B6FB3' },
  { label: 'Wednesday', theme: 'VOICE', color: '#2F3A78' },
  { label: 'Thursday', theme: 'MOVEMENT', color: '#4C8C4A' },
  { label: 'Friday', theme: 'CREATIVITY', color: '#D9A441' },
  { label: 'Saturday', theme: 'MUSIC', color: '#C0447A' },
];

// The 28-day cycle: 4 phases, 1 week each.
export const CYCLE_PHASES = [
  {
    phase: 1,
    name: 'Ideation / Seed Planting',
    duration: '1 week',
    activities: ['Production goals', 'Project team formation', 'Meeting'],
    color: '#4C8C4A',
  },
  {
    phase: 2,
    name: 'Cultivation / Test Foundation',
    duration: '1 week',
    activities: ['Pre-production', 'Prototype', 'Workshop'],
    color: '#2A8F85',
  },
  {
    phase: 3,
    name: 'Editing / Revision',
    duration: '1 week',
    activities: ['Production', 'Collaboration', 'Session', 'Webinar'],
    color: '#D9A441',
  },
  {
    phase: 4,
    name: 'Final Production / Release',
    duration: '1 week',
    activities: ['Production', 'Community Event', 'Live-In-Studio', 'On-the-Air', 'Web'],
    color: '#D16A4B',
  },
];
